import React from 'react';
import moment from 'moment';
import { T, useTranslate } from 'shared/helper/translate';
export var DATE_TIME_FORMAT = 'researcher-date-format';
export var DATE_ONLY_FORMAT = 'researcher-date-only-format';
export var dateString = function dateString(t, date, dateFormat, showExactTime) {
  return t(dateFormat, {
    day: date.format('DD'),
    month: date.format('MM'),
    monthName: t(date.format('MMM')),
    time: showExactTime ? date.format('h:mm A') : date.format('ha'),
    twentyFourHourTime: showExactTime ? date.format('H:mm') : date.format('H:00'),
    year: date.format('YYYY')
  });
};
var Date = function Date(_ref) {
  var inline = _ref.inline,
    source = _ref.source,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? '%s' : _ref$format,
    _ref$dateFormat = _ref.dateFormat,
    dateFormat = _ref$dateFormat === void 0 ? DATE_TIME_FORMAT : _ref$dateFormat,
    showExactTime = _ref.showExactTime;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var deadline = showExactTime ? moment(source) : moment(source).add(1, 'hour');
  return /*#__PURE__*/React.createElement(T.md, {
    inline: inline,
    source: format,
    params: dateString(t, deadline, dateFormat, showExactTime)
  });
};
export default Date;